import { Environment } from '../../shared/environment/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Order } from '../../model/order';
import { OcapiUrlConstants } from '../../shared/ocapi-url-constants';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { ActivateStreamingBundleUtil } from '../../utils/streaming-bundles/activate-streaming-bundle.util';
var OcapiSynchronousService = /** @class */ (function () {
    function OcapiSynchronousService(httpClient) {
        this.httpClient = httpClient;
    }
    OcapiSynchronousService.prototype.activatePack = function (order) {
        var activatePackObservable;
        if (order.type === Order.DAYPASS) {
            activatePackObservable = this.activateDayPass(order);
        }
        else {
            activatePackObservable = this.activateContentPack(order);
        }
        return activatePackObservable;
    };
    OcapiSynchronousService.prototype.activateStreamingService = function (basket) {
        var _this = this;
        var url = this.getSalesServiceActionUrl() + '/streaming-subscriptions/manage-streaming-services';
        var request = ActivateStreamingBundleUtil.createRequest(basket);
        var httpOptions = this.createHeaderOptions(OmapiIdsUtils.accessToken);
        return this.httpClient.post(url, request, httpOptions).pipe(mergeMap(function (salesOrder) {
            if (salesOrder.feasibilityCheckRequired) {
                return _this.feasibilityCheck(salesOrder);
            }
            return of(salesOrder);
        }), mergeMap(function (salesOrder) {
            return _this.submitSalesOrder(salesOrder);
        }));
    };
    OcapiSynchronousService.prototype.submitSalesOrder = function (salesOrder) {
        var url = this.getSalesServiceV2ActionUrl() + ("/salesorders/" + salesOrder.id + "/submit");
        var httpOptions = this.createHeaderOptions(OmapiIdsUtils.accessToken);
        return this.httpClient.post(url, null, httpOptions).pipe(map(function (result) {
            return result;
        }));
    };
    OcapiSynchronousService.prototype.feasibilityCheck = function (salesOrder) {
        var url = this.getSalesServiceActionUrl() + ("/salesorders/" + salesOrder.id + "/feasibilitycheck");
        var payload = ActivateStreamingBundleUtil.createFeasibilityRequest(salesOrder);
        var httpOptions = this.createHeaderOptions(OmapiIdsUtils.accessToken);
        return this.httpClient.post(url, payload, httpOptions).pipe(map(function (result) {
            return result;
        }));
    };
    OcapiSynchronousService.prototype.getProductsWaitingToGetActivatedForLocation = function (locationId) {
        var url = this.getProductService() + "/products?status=ACTIVE,SUSPENDED,ACTIVATION_IN_PROGRESS,DISCONNECTION_IN_PROGRESS,DISCONNECTION_PASSED_PONR,DISCONNECTED";
        var httpOptions = this.createHeaderOptions(OmapiIdsUtils.accessToken);
        return this.httpClient.get(url, httpOptions).pipe(map(function (result) {
            return result.filter(function (ncProduct) {
                return ncProduct.locationId === locationId;
            }).map(function (ncProduct) {
                ncProduct.omapiId = ncProduct.specurl.split('/').pop();
                ncProduct.options.map(function (option) {
                    option.omapiId = option.specurl.split('/').pop();
                });
                return ncProduct;
            });
        }));
    };
    OcapiSynchronousService.prototype.activateTrial = function (trial) {
        var _this = this;
        var activateTrialPackUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatetrial';
        var body = {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            vouchernumber: trial.voucherid,
            salesofferingspecificationid: trial.salesOfferingSpecificationId,
            salesentity: { salesentityid: '68625', salesperson: 'EOS TV Shop' }
        };
        return this.httpClient.post(activateTrialPackUrl, body, this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(map(function (response) { return _this.mappedResponse(response); }));
    };
    OcapiSynchronousService.prototype.activateContentPack = function (order) {
        var _this = this;
        var activateContentPackUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatecontentpack';
        var body = {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            activatedproductomapiid: order.packOmapiId,
            activatedsubproductomapiid: order.subPackOmapiId ? order.subPackOmapiId : null,
            term: order.term ? Number.parseInt(order.term) : 1
        };
        return this.httpClient.post(activateContentPackUrl, body, this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(map(function (response) { return _this.mappedResponse(response); }));
    };
    OcapiSynchronousService.prototype.activateDayPass = function (order) {
        var _this = this;
        var activateDayPassUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatedaypass';
        return this.httpClient.post(activateDayPassUrl, this.createActivateDaypassBody(order.packOmapiId), this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(map(function (response) { return _this.mappedResponse(response); }));
    };
    OcapiSynchronousService.prototype.createHeaderOptions = function (accessToken) {
        return {
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            })
        };
    };
    OcapiSynchronousService.prototype.mappedResponse = function (parsedBody) {
        return {
            id: parsedBody.id,
            success: parsedBody.success,
            errorCode: parsedBody.errorcode,
            errorMessage: parsedBody.errormessage
        };
    };
    OcapiSynchronousService.prototype.createActivateDaypassBody = function (activateDayPassOmapiId) {
        return {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            omapiid: activateDayPassOmapiId,
            salesofferingspecificationid: '141',
            salesentity: { salesentityid: '68625', salesperson: 'EOS TV Shop' }
        };
    };
    OcapiSynchronousService.prototype.getBaseUrl = function () {
        return Environment.environmentConfig().baseApiUrl;
    };
    OcapiSynchronousService.prototype.getBaseUrlForInt = function () {
        return Environment.environmentConfig().baseApiUrlForInt;
    };
    OcapiSynchronousService.prototype.getOcapiAdaptorActionUrl = function () {
        return this.getBaseUrl() + OcapiUrlConstants.OCAPI_ADAPTOR_ACTION;
    };
    OcapiSynchronousService.prototype.getOcapiAdaptorActionUrlForInt = function () {
        return this.getBaseUrlForInt() + OcapiUrlConstants.OCAPI_ADAPTOR_ACTION;
    };
    OcapiSynchronousService.prototype.getSalesServiceActionUrl = function () {
        return this.getBaseUrl() + OcapiUrlConstants.OCAPI_SALES_SERVICE;
    };
    OcapiSynchronousService.prototype.getSalesServiceV2ActionUrl = function () {
        return this.getBaseUrl() + OcapiUrlConstants.OCAPI_SALES_SERVICE_V2;
    };
    OcapiSynchronousService.prototype.getProductService = function () {
        return this.getBaseUrl() + OcapiUrlConstants.OCAPI_PRODUCT_SERVICE;
    };
    return OcapiSynchronousService;
}());
export { OcapiSynchronousService };
